import { Injectable } from '@angular/core';
// import { DocumentRef, WindowRef } from '@agm/core/utils/browser-globals';

/**
 * The configs of code tagged with credit are licensed to
 * Copyright (c) 2017 Sebastian Müller
 *  under the MIT licence
 */

// credit
export enum GoogleMapsScriptProtocol {
	HTTP = 1,
	HTTPS = 2,
	AUTO = 3
}

export interface LazyMapsAPILoaderConfigLiteral {
	/**
	 * The Google Maps API Key (see:
	 * https://developers.google.com/maps/documentation/javascript/get-api-key)
	 */
	apiKey?: string;

	/**
	 * The Google Maps client ID (for premium plans).
	 * When you have a Google Maps APIs Premium Plan license, you must authenticate
	 * your application with either an API key or a client ID.
	 * The Google Maps API will fail to load if both a client ID and an API key are included.
	 */
	clientId?: string;

	/**
	 * The Google Maps channel name (for premium plans).
	 * A channel parameter is an optional parameter that allows you to track usage under your client
	 * ID by assigning a distinct channel to each of your applications.
	 */
	channel?: string;

	/**
	 * Google Maps API version.
	 */
	apiVersion?: string;

	/**
	 * Host and Path used for the `<script>` tag.
	 */
	hostAndPath?: string;

	/**
	 * Protocol used for the `<script>` tag.
	 */
	protocol?: GoogleMapsScriptProtocol;

	/**
	 * Defines which Google Maps libraries should get loaded.
	 */
	libraries?: string[];

	/**
	 * The default bias for the map behavior is US.
	 * If you wish to alter your application to serve different map tiles or bias the
	 * application, you can overwrite the default behavior (US) by defining a `region`.
	 * See https://developers.google.com/maps/documentation/javascript/basics#Region
	 */
	region?: string;

	/**
	 * The Google Maps API uses the browser's preferred language when displaying
	 * textual information. If you wish to overwrite this behavior and force the API
	 * to use a given language, you can use this setting.
	 * See https://developers.google.com/maps/documentation/javascript/basics#Language
	 */
	language?: string;
}
// export interface LocationPickerConfig {
//   protocol?: GoogleMapsScriptProtocol;
//   apiKey?: string;
// }
@Injectable()
export class LocationPickerService {
	protected readonly _scriptId: string;
	private _config: LazyMapsAPILoaderConfigLiteral = {
		protocol: 1,
		apiKey: 'dsagewfwerfwe7676wef45we4f654w53',
		region: 'ZA'
		// callbackName: 'sayHi'
	};
	private _set = false;
	private _scriptElement: HTMLElement;

	set config(config: any) {
		if (this._set === false) {
			this._config = config;
			this._scriptElement = this.makeScript('sayHi');
			// console.log(this._scriptElement);
		} else {
			// console.log('can only set config once per service instance');
		}
	}

	private _documentRef;
	private _windowRef;
	// constructor(private _documentRef: DocumentRef, _window: WindowRef) {}

	makeScript(callbackName) {
		const scriptOnPage = this._documentRef.getNativeDocument().getElementById(this._scriptId);
		if (scriptOnPage) {
			return scriptOnPage;
		}

		const script = this._documentRef.getNativeDocument()?.createElement('script', 'script');
		script.type = 'text/javascript';
		script.async = true;
		script.defer = true;
		script.id = this._scriptId;
		script.src = this._getScriptSrc(callbackName);
		this._documentRef.getNativeDocument()?.body.appendChild(script);
		this._scriptElement = script;
		return this._scriptElement;
	}

	// partial credit
	protected _getScriptSrc(callbackName): string {
		const protocolType: GoogleMapsScriptProtocol = (this._config && this._config.protocol) || GoogleMapsScriptProtocol.HTTPS;
		let protocol: string;

		switch (protocolType) {
			case GoogleMapsScriptProtocol.AUTO:
				protocol = '';
				break;
			case GoogleMapsScriptProtocol.HTTP:
				protocol = 'http:';
				break;
			case GoogleMapsScriptProtocol.HTTPS:
				protocol = 'https:';
				break;
		}

		const hostAndPath: string = this._config.hostAndPath || 'maps.googleapis.com/maps/api/js';
		const queryParams: { [key: string]: string | Array<string> } = {
			v: this._config.apiVersion || '3',
			callback: callbackName,
			key: this._config.apiKey,
			client: this._config.clientId,
			channel: this._config.channel,
			libraries: this._config.libraries,
			region: this._config.region,
			language: this._config.language
		};
		const params: string = Object.keys(queryParams)
			.filter((k: string) => queryParams[k] != null)
			.filter((k: string) => {
				// remove empty arrays
				return !Array.isArray(queryParams[k]) || (Array.isArray(queryParams[k]) && queryParams[k].length > 0);
			})
			.map((k: string) => {
				// join arrays as comma seperated strings
				const i = queryParams[k];
				if (Array.isArray(i)) {
					return { key: k, value: i?.join(',') };
				}
				return { key: k, value: queryParams[k] };
			})
			.map((entry: { key: string; value: string }) => {
				return `${entry.key}=${entry.value}`;
			})
			?.join('&');
		return `${protocol}//${hostAndPath}?${params}`;
	}

	get scriptElement() {
		if (!this._scriptElement) {
			this.makeScript(null);
		}
		return this._scriptElement;
	}
}
